var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 6,
    viewBox: "0 0 33 6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(0.251 -0.234)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 3.5,
    cy: 3,
    rx: 3.5,
    ry: 3,
    transform: "translate(-0.251 0.234)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 3.5,
    cy: 3,
    rx: 3.5,
    ry: 3,
    transform: "translate(12.749 0.234)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 3.5,
    cy: 3,
    rx: 3.5,
    ry: 3,
    transform: "translate(25.749 0.234)",
    fill: "#707070"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.d6f8748fba27ea8f09121e72be0d6d18.svg";
export { ForwardRef as ReactComponent };